module.exports = [{
      plugin: require('D:/Code/react_/gatsby/first-proj/node_modules/_gatsby-plugin-offline@2.0.5@gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('D:/Code/react_/gatsby/first-proj/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
